// 计费模式
import { checkPasswd } from '@/utils/utils';

export const chargeTypeEnum = {
  Minutes: 'minutes', // 分钟数计费
  ParallelConcurrent: 'parallelConcurrent', // 并行并发
  totalConcurrent: 'totalConcurrent' // 累计并发
};

export const chargeType = {
  [chargeTypeEnum.Minutes]: '分钟数',
  [chargeTypeEnum.ParallelConcurrent]: '并行并发',
  [chargeTypeEnum.totalConcurrent]: '累计并发'
};

// 用户状态
export const statusEnum = {
  Normal: 'normal',
  Frozen: 'frozen',
  Expired: 'expired',
  Arrears: 'arrears'
};

export const status = {
  [statusEnum.Normal]: '正常使用',
  [statusEnum.Frozen]: '已冻结',
  [statusEnum.Expired]: '已过期',
  [statusEnum.Arrears]: '已欠款',
};

export const productionEnum = {
  Live: '直播',
  Vod: '点播',
  VClass: '研讨会'
};

// 默认表单校验
export const defaultFormRules = {
  email: [
    { type: 'string', message: '请输入邮箱', required: true },
    { type: 'email', message: '请输入正确的邮箱格式' }
  ],
  phone: [
    { type: 'string', message: '请输入联系人手机号码', required: true },
    { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '手机号格式错误' },
  ],
  password: [
    { type: 'string', message: '请输入密码', required: true },
    {
      // eslint-disable-next-line sonarjs/no-identical-functions
      validator: (rule, value, callback) => {
        if (!checkPasswd(value)) {
          callback(new Error('密码格式为8~16位，且必须包含数字与字母的组合'));
        } else {
          callback();
        }
      }
    }
  ]
};
